import { render, staticRenderFns } from "./ContractInfo.vue?vue&type=template&id=4bb2ab2c&scoped=true"
import script from "./ContractInfo.vue?vue&type=script&lang=js"
export * from "./ContractInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb2ab2c",
  null
  
)

export default component.exports